import React, { Component } from 'react'
import BaseLayout from './components/BaseLayout'
import Theme from './components/Theme'
import CssBaseline from '@material-ui/core/CssBaseline';

class App extends Component {
  render() {
    return (
      <div>
        <Theme>
          <CssBaseline />
          <BaseLayout/>
        </Theme>
      </div>
    )
  }
}
export default App